<template>
    <div>
        <label class="text-base font-medium text-gray-900">{{ name }}</label>
        <p v-if="description" class="text-sm leading-5 text-gray-500">{{ description }}</p>
        <fieldset>
            <legend class="sr-only">{{ name }}</legend>
            <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-[10px]">
                <div v-for="item in items" :key="item.id" class="flex items-center">
                    <input @click="handleClick(item.id)" :id="item.id" name="toggle-status" type="radio" :checked="selected === item.id" class="focus:ring-green-500 h-4 w-4 text-green-600 border-gray-300"/>
                    <label :for="item.id" class="ml-3 block text-sm font-medium text-gray-700">
                        {{ item.title }}
                    </label>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script setup>
import {onMounted, ref, watch} from "vue";

const props = defineProps({name: String, description: String, options: Array})
const emit = defineEmits(['update'])

const items = ref([
    {id: 'yes', title: 'Yes'},
    {id: 'no', title: 'No'},
])
const selected = ref({})

onMounted(() => {
    if (props.options) {
        items.value = props.options
    }
    selected.value = items.value[0].id
})
watch(selected, (value, prev) => {
    if (value !== prev) {
        emit('update', value)
    }
})

const handleClick = (value) => {
    selected.value = value
}
</script>
